// The vocabulary a sync run speaks, in one place because the page needs it too.
//
// CLIENT-SAFE ON PURPOSE: nothing here reaches the server or the database. The
// page imports it so the codes and their labels cannot drift apart, which they
// would the moment the two lists lived in different files.

// Why a row was not pushed. ALL FOUR ARE FACTS ABOUT OUR OWN DATA, worked out
// fresh on every pass and never written down anywhere -- a stock with no sku
// does not become a sku by being remembered.
//
// Nothing the PLATFORM says is in here any more. `notFound`, `badQuantity`,
// `unlimited` and `duplicate` used to be, each stored on the listing so a later
// pass would not ask again, with rules about who could write one and who could
// withdraw it. The token is checked once before a pass starts, so a refusal
// afterwards means this sku and nothing else -- and the answer to every one of
// them is the same, which is to leave it alone. A distinction that changes no
// behaviour is not worth a vocabulary.
const REASONS = {
  unknownSku: '找不到單品',
  blankSku: '單品沒有貨號',
  suspended: '單品已停用',
  badQuantity: '數量不合法',
}

// What happened to one row. There is no `unchanged`: a row that has not moved
// since the last pass is never read at all, because the window is a query
// rather than a comparison made per row.
const OUTCOMES = {
  write: '需更新',
  skip: '略過',
  ok: '已更新',
  // The platform answered about this sku and would not take it. Nothing to do
  // and nothing to remember: the row is marked as sent so the pass moves on.
  refused: '平台拒絕',
  // The run or the network, not the sku. The row stays due, so the next pass
  // sends the same absolute quantity again for free.
  failed: '稍後重試',
}

// The run as a whole.
const STATUSES = {
  running: '執行中',
  done: '完成',
  aborted: '已中止',
  failed: '失敗',
  busy: '已有一個同步在執行',
}

const MODES = {
  preview: '試算',
  apply: '同步',
}

export { REASONS, OUTCOMES, STATUSES, MODES }
